
import { Vue, Options, prop } from "vue-class-component";
import { TimeSlot } from "./types";

class Props {
  titlePickup = prop<string>({
    default: "Pilih jam Pick Up",
    type: String
  });
  times = prop<TimeSlot[]>({
    default: () => [],
    type: Array as () => TimeSlot[]
  });
  modelValue = prop<string>({
    default: "",
    type: String
  });
  maxHeight = prop<number>({
    default: 300,
    required: false,
    type: Number
  });
}

@Options({
  emits: ["update:modelValue", "onSelect", "onRemove"]
})
export default class TimeSlotDropdown extends Vue.with(Props) {
  isMenu = false;
  optimizedHeight = this.maxHeight;
  preferredOpenDirection = "below";

  get nearestAvailableLabel(): string {
    const firstAvailable = this.times.find((slot) => !slot.disabled);
    return firstAvailable ? firstAvailable.label : "";
  }

  get displayLabel(): string {
    if (!this.modelValue) return "";
    const selected = this.times.find((slot) => slot.value === this.modelValue);
    return selected ? selected.label : "";
  }

  get isAbove(): boolean {
    return this.preferredOpenDirection === "above";
  }

  onSelectTime(slot: TimeSlot): void {
    if (slot.disabled) return;
    this.$emit("update:modelValue", slot.value);
    this.$emit("onSelect");
    this.showMenu();
  }

  onClear(): void {
    this.$emit("update:modelValue", "");
    this.$emit("onRemove");
  }

  isSelected(slot: TimeSlot): boolean {
    return slot.value === this.modelValue;
  }

  showMenu(): void {
    this.isMenu = !this.isMenu;
    if (this.isMenu) {
      this.adjustPosition();
    }
  }

  private adjustPosition(): void {
    if (typeof window === "undefined") return;

    const spaceAbove = this.$el.getBoundingClientRect().top;
    const spaceBelow =
      window.innerHeight - this.$el.getBoundingClientRect().bottom;
    const hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

    if (hasEnoughSpaceBelow || spaceBelow > spaceAbove) {
      this.preferredOpenDirection = "below";
      this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
    } else {
      this.preferredOpenDirection = "above";
      this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
    }
  }
}
